import { render, staticRenderFns } from "./input-number.component.vue?vue&type=template&id=51181934&scoped=true&"
import script from "./input-number.component.vue?vue&type=script&lang=ts&"
export * from "./input-number.component.vue?vue&type=script&lang=ts&"
import style0 from "./input-number.component.vue?vue&type=style&index=0&id=51181934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51181934",
  null
  
)

export default component.exports